module.exports = __webpack_public_path__ + "media/img/Landing_Page/meditation_0320-b4b2f8094a84af7ca513e5caa15fc408.jpg";